var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutsourcing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(-4822 -2812)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4822 2812)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4789.039 -3541)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.961 735)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1,9.187a9.187,9.187,0,1,0-9.187,9.187A9.2,9.2,0,0,0,30.1,9.187Zm-15-5.812a8.225,8.225,0,0,1,11.247-.342l-.64.724A7.243,7.243,0,0,0,15.482,13.981l-.724.641A8.223,8.223,0,0,1,15.1,3.374Zm1.018,11.242a7.379,7.379,0,0,0,5.4,1.791,7.054,7.054,0,0,0,4.521-2.092,7.256,7.256,0,0,0,.3-9.923l.724-.641A8.21,8.21,0,0,1,15.476,15.341Zm0,0",
    transform: "translate(-2.054)",
    fill: "#35bb7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.459,29.106a1.568,1.568,0,0,0,2.217,2.218l7.761-7.761L8.22,21.346Zm.992,1.71a.484.484,0,1,1,.484-.484A.484.484,0,0,1,1.451,30.816Zm0,0",
    transform: "translate(0 -3.74)",
    fill: "#35bb7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.724,21.089l.684.684,1.685-1.685q-.358-.326-.684-.684Zm0,0",
    transform: "translate(-2.054 -3.399)",
    fill: "#35bb7a"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.815 739.395)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.842,295.083a2.142,2.142,0,1,1,2.142-2.142A2.1,2.1,0,0,1,82.842,295.083Zm0-3.568a1.426,1.426,0,1,0,1.426,1.426A1.432,1.432,0,0,0,82.842,291.516Z",
    transform: "translate(-80.7 -290.8)",
    fill: "#dfe3e5",
    stroke: "#dfe3e5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.793,397.668a.34.34,0,0,1-.358-.358v-1.426a1.094,1.094,0,0,0-1.068-1.068H48.084a1.094,1.094,0,0,0-1.068,1.068v1.426a.358.358,0,1,1-.716,0v-1.426a1.764,1.764,0,0,1,1.784-1.784h4.283a1.764,1.764,0,0,1,1.784,1.784v1.426A.34.34,0,0,1,53.793,397.668Z",
    transform: "translate(-46.3 -394.1)",
    fill: "#dfe3e5",
    stroke: "#dfe3e5",
    strokeWidth: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsourcing);
export default __webpack_public_path__ + "static/media/outsourcing.c7b415462f4f14a9ee87c1bbf9c2acba.svg";
export { ForwardRef as ReactComponent };